export enum Variant {
  ACTION = 'action',
  CTA = 'cta',
  DANGER = 'danger',
  DEFAULT = 'default',
  PLAIN = 'plain',
  STROKE = 'stroke',
}
